import React from 'react';
import { Card } from 'primereact/card';
import HandlingUnitKanban from './HandlingUnitKanban';

const HandlingUnitBoard: React.FC = () => {
    return (
        <div className="grid">
            <div className="col-12">
                <Card title="Handling Unit Board">
                    <HandlingUnitKanban />
                </Card>
            </div>
        </div>
    );
};

export default HandlingUnitBoard;
